const config = require('../../package.json');

module.exports = config;
